import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import ProgressLoader from 'components/essentials/ProgressLoader/ProgressLoader';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import LivestreamPageUI from './LivestreamPageUI';
import { getVideoEntries, videoCategoryList } from './utils';

const LivestreamPage = ({ isAdmin = false } = {}) => {
  // TODO: Load currently streaming live video from Vimeo
  const videoStreamingLive = null; /* {
    category: 'Styling & tutorials',
    title: 'Aero Media Console',
    videoId: '517944137',
  } */
  const limit = 20;
  const [page, updatePage] = useState(0);
  const [videos, updateVideos] = useState([]);
  const [hasMoreVideos, updateHasMoreVideos] = useState(true);

  useEffect(() => {
    getVideoEntries({
      params: {
        limit,
        skip: page ? page * limit : 0,
      },
    })
      .then(videoList => {
        const newVideos = videoList ?? [];

        if (newVideos.length > 0) {
          updateVideos(prevVideos => [...prevVideos, ...newVideos]);
          updateHasMoreVideos(true);
        } else {
          updateHasMoreVideos(false);
        }
      })
      .catch(e => e);
  }, [page]);

  if (isAdmin) {
    return (
      <FixedWidthContainer className="text-center">
        Place holder for videos blog.
      </FixedWidthContainer>
    );
  }

  const loadMoreVideos = () => {
    updatePage(page + 1);
  };

  const videoCategories = videoCategoryList();

  return videos.length > 0 ? (
    <LivestreamPageUI
      videos={videos}
      videoCategories={videoCategories}
      isAdmin={isAdmin}
      videoStreamingLive={videoStreamingLive}
      loadMoreVideos={loadMoreVideos}
      hasMoreVideos={hasMoreVideos}
    />
  ) : (
    <ProgressLoader />
  );
};

LivestreamPage.propTypes = {
  isAdmin: PropTypes.bool,
};

export default LivestreamPage;
